import api from "@/api/v1-jwt/config/api";

export const getAllAccounts = async (userId) => {
  if (!userId) {
    throw new Error("[GET_ALL_ACCOUNTS] User ID missing.");
  }

  try {
    const { data } = await api.get(`/platform/accounts/${userId}`);

    return data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const transferDeposit = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[TRANSFER_DEPOSIT] User ID missing.");
  }

  try {
    const { data } = await api.post(
      `/platform/transfers/move_money/deposit/${userId}`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const transferWithdraw = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[TRANSFER_WITHDRAW] User ID missing.");
  }

  try {
    const { data } = await api.post(
      `/platform/transfers/move_money/withdraw/${userId}`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const transferThirdParty = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[TRANSFER_THIRD_PARTY] User ID missing.");
  }

  try {
    const { data } = await api.post(
      `/platform/transfers/move_money/third_party/${userId}`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const transferMoney = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[TRANSFER_MONEY] User ID missing.");
  }

  try {
    const { data } = await api.post(`/platform/transfers/${userId}`, payload);

    return data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};
